export interface IThemeSettings {
    preset: string;
    primary: string;
    surface: string;
    darkTheme: boolean;
    menuMode: string;
}

export interface IUserUiPreferenceEnvelope {
    schemaVersion: number;
    updatedAtUtc: string;
    theme: IThemeSettings;
}

export const THEME_SCHEMA_VERSION = 1;

export const DEFAULT_THEME_SETTINGS: IThemeSettings = {
    preset: 'Aura',
    primary: 'lime',
    surface: 'viva',
    darkTheme: false,
    menuMode: 'static'
};

export function createDefaultEnvelope(): IUserUiPreferenceEnvelope {
    return {
        schemaVersion: THEME_SCHEMA_VERSION,
        updatedAtUtc: new Date().toISOString(),
        theme: { ...DEFAULT_THEME_SETTINGS }
    };
}
